export enum PermitWorkPlaceViewEnum {
    Start = 1,
    Base = 2,
    Premium = 3,
    CreateNew = 4
}
